import axiosInstance from "../../api/axiosInstance";
const BASE = "api/lead-tracking";

export async function fetchStages() {
  const { data } = await axiosInstance.get(`${BASE}/leads/stages`);
  if (!data?.success) throw new Error(data?.message || "Failed to fetch stages");
  return data.data;
}

export async function createStage(name) {
  const { data } = await axiosInstance.post(`${BASE}/leads/stages`, { name });
  if (!data?.success) throw new Error(data?.message || "Failed to create stage");
  return data.data;
}

export async function updateStage(stageId, payload) {
  const { data } = await axiosInstance.put(`${BASE}/leads/stages/${stageId}`, payload);
  if (!data?.success) throw new Error(data?.message || "Failed to update stage");
  return data.data;
}

export async function deleteStage(stageId) {
  const { data } = await axiosInstance.delete(`${BASE}/leads/stages/${stageId}`);
  if (!data?.success) throw new Error(data?.message || "Failed to delete stage");
  return true;
}

export async function fetchFunnel({ from_date, to_date, staff_ids }) {
  const { data } = await axiosInstance.get(`${BASE}/leads/funnel`, { params: { from_date, to_date, staff_ids } });
  if (!data?.success) throw new Error(data?.message || "Failed to fetch funnel data");
  return data.data;
}

export async function fetchTrend({ from_date, to_date, group_by, staff_ids }) {
  const { data } = await axiosInstance.get(`${BASE}/leads/trend`, { params: { from_date, to_date, group_by, staff_ids } });
  if (!data?.success) throw new Error(data?.message || "Failed to fetch trend data");
  return data.data;
}

export async function fetchAddresses({ page = 1, limit = 20, search, stage_from, stage_to, order_by = "latest_stage_at", order_dir = "desc" } = {}) {
  const { data } = await axiosInstance.get(`${BASE}/leads/addresses`, {
    params: { page, limit, search, stage_from, stage_to, order_by, order_dir },
  });
  if (!data?.success) throw new Error(data?.message || "Failed to fetch addresses");
  return { data: data.data || [], pagination: data.pagination || {} };
}

export async function fetchStageDuration({ from_stage_id, to_stage_id, from_date, to_date, staff_ids }) {
  const { data } = await axiosInstance.get(`${BASE}/leads/stage-duration`, {
    params: { from_stage_id, to_stage_id, from_date, to_date, staff_ids },
  });
  if (!data?.success) throw new Error(data?.message || "Failed to fetch stage duration");
  return data.data;
}

export async function fetchStaffUsers() {
  const { data } = await axiosInstance.get(`${BASE}/leads/staff-users`);
  if (!data?.success) throw new Error(data?.message || "Failed to fetch staff Users");
  return data.data;
}
